export const actions = {
  editar: 'editar',
  confirmar: 'confirmar',
  alterarValor: 'alterarValor',
  cancelarModal: 'cancelarModal',
  gravarValor: 'gravarValor',
  alterarLoading: 'alterarLoading',
  reiniciarValores: 'reiniciarValores',
};

export const reducer = (state, action) => {
  switch (action.type) {
    case actions.editar:
      return { ...state, editando: true };
    case actions.confirmar:
      return {
        ...state,
        mostrarModalConfirmacao: state.monthlyEstimate !== state.remuneracaoBaseInicial,
        editando: state.monthlyEstimate !== state.remuneracaoBaseInicial,
      };
    case actions.alterarValor:
      return { ...state, monthlyEstimate: action.monthlyEstimate };
    case actions.reiniciarValores:
      return {
        ...state,
        monthlyEstimate: action.monthlyEstimate,
        remuneracaoBaseInicial: action.monthlyEstimate,
      };
    case actions.cancelarModal:
      return {
        ...state,
        monthlyEstimate: state.remuneracaoBaseInicial,
        editando: false,
        mostrarModalConfirmacao: false,
      };
    case actions.gravarValor:
      return {
        ...state,
        editando: false,
        mostrarModalConfirmacao: false,
        remuneracaoBaseInicial: action.monthlyEstimate,
        monthlyEstimate: action.monthlyEstimate,
      };
    case actions.alterarLoading:
      return { ...state, loading: action.loading };
    default:
      throw new Error(
        `Action ${action.type} not found.\nstate: ${JSON.stringify(state)}\naction: ${JSON.stringify(action)}`
      );
  }
};
